<template>
  <b-button-group>
    <b-button
      v-for="m of meses"
      :key="m.id"
      :title="m.nome"
      :variant="btnVariant(m.id)"
      @click="btnIndex = m.id - 1"
      >{{ m.red }}</b-button
    >
  </b-button-group>
</template>

<script lang="js">
export default {
  name: "ButtonMeses",

  props: {
    value: {
      type: Number,
      default: new Date().getMonth() + 1,
    },
  },

  data() {
    return {
      meses: [
        { id: 1, red: "Jan", nome: "Janeiro" },
        { id: 2, red: "Fev", nome: "Fevereiro" },
        { id: 3, red: "Mar", nome: "Março" },
        { id: 4, red: "Abr", nome: "Abril" },
        { id: 5, red: "Mai", nome: "Maio" },
        { id: 6, red: "Jun", nome: "Junho" },
        { id: 7, red: "Jul", nome: "Julho" },
        { id: 8, red: "Ago", nome: "Agosto" },
        { id: 9, red: "Set", nome: "Setembro" },
        { id: 10, red: "Out", nome: "Outubro" },
        { id: 11, red: "Nov", nome: "Novembro" },
        { id: 12, red: "Dez", nome: "Desembro" },
      ],
      selected: this.value || new Date().getMonth() + 1,
    };
  },

  computed: {
    btnIndex: {
      get() {
        return this.selected - 1;
      },
      set(value) {
        this.selected = value + 1;
      },
    },
  },

  methods: {
    btnVariant(mes) {
      return mes == this.btnIndex + 1 ? "primary" : "secondary";
    },
  },

  watch: {
    selected(mes) {
      this.$emit("input", mes);
    },
  },
};
</script>
